import React, { useContext, useEffect, useReducer, useState } from "react";
import { setExternalSignIn, setGoHome, setLoader, setLoaderClosed } from "../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { currentWidget, setShowCustomPopup } from "../../../action/action";
import { MyContext } from ".";
import { inAppBrowser } from "../../JS/inAppBrowser";
import Loader from "../../UI/loader";

 // return formatted name from "SignUp" -> "Sign Up"
 const formatName=(name)=>{
    let updatedName="";
    for(let c of name){
        if(c.toUpperCase()==c) updatedName+=" ";
        updatedName+=c;
    }
    return updatedName.trim();
}

const SettingPage = (props) => {

    const { t } = props;
    const [isLoading, setIsLoading]=useState(true);
    const [currentWidgetPrevData, setCurrentWidgetPrevData] = useState({});
    const { dispatchCurrentPage, IPossiblePages, apiData } = useContext(MyContext)


    const handleGoBack = () => {
        dispatchCurrentPage({ type: IPossiblePages.LANDING_PAGE })
    }

    const onItemClick=(item)=>{
        inAppBrowser(item.uri, props, true, { displayName: item.label, dontSetCurrentWidget: true, meta:{loadInExternalBrowser: Boolean(item.loadInExternalBrowser)} })
    }

    const startFlow =()=>{
        if(apiData.URLS.isFetching){
            setIsLoading(true);
        } else if(!apiData.URLS.isFetching && !apiData.URLS.data){
            //show error using top popup
            props.closeOrderPopUp(true, apiData.URLS.errorMsg, "", true)
            handleGoBack();
        } else{
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        startFlow();

        setCurrentWidgetPrevData(props.currentWidgetObj)
        props.currentWidget({widgetType: true});

        return () => {
            props.currentWidget(currentWidgetPrevData);
        }
    },[])

    useEffect(()=>{
        startFlow();
    },[apiData.URLS])



    return (
        <>
            {
                !isLoading ?
                <div class="setting-page">
                <div class="content" >
                    <div class="heading"> Settings</div>
                    <div class="functional-widgets" >
                               
                            { apiData.URLS.data && apiData.URLS.data.map((item)=>{

                                   
                                    return  item && ( !(Object(item).hasOwnProperty('shouldDisplay')) || item.shouldDisplay )  && <div class={`tile-selection tile-container`}  onClick={()=>onItemClick(item)}>
                                            {/* <div class="tile-selection-img">
                                                <img src="http://144.202.36.79:8080/../cmsData/hoteligenceClient/mobileApp/virginPosterImage.jpg"></img>
                                            </div> */}
                                            <div class="tile-selection-text">
                                                <div class="tile-selection-heading">{formatName(item.label)}</div>
                                                {/* <div class="tile-selection-desc">Wherever you're headed, we hope to see you there.</div> */}
                                            </div>
                                        </div>
                                

                                })
                            }
                       </div>
                    {/* <div class="controls" onClick={props.signOutSSO}>
                        <button class="secondary" >
                            Sign out
                        </button>
                    </div> */}
                </div>
                </div>
                :
                <Loader
                    enableClose={true}
                    showClose={props.showLoaderClose} 
                    close={() => {
                                props.setLoader(false, null, false)
                                props.setLoaderClosed(true)
                            }} 
                    displayMsg={props.loaderMessage} />
            }
           
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
        externalSignIn: state.store2.externalSignIn,
        selectedHomePage: state.store2.currentHomePage,
        showNewHeader: state.store2.showNewHeader,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        widgetList: state.store2.sideNavBar.widgetList,
        notifications: state.store.home.gJnotifications,
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestName: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        currentHomePage: state.store2.currentHomePage,
        selectedHomePage: state.store2.currentHomePage,
        menuColor: state.store.home.MenuColor,
        preCheckInBookingDueIn: state.store2.preCheckInBookingDueIn,
        widgetList: state.store2.sideNavBar.widgetList,
        showLoaderClose: state.store2.showLoaderClose,
        loaderMessage: state.store2.loaderMessage,
 

    }
}
export default connect(mapStateToProps, { setGoHome, currentWidget, setShowCustomPopup, closeOrderPopUp, sendAnalytics, setExternalSignIn, setLoader, setLoaderClosed })(
    withTranslation("translations")(SettingPage)
);